import React, { useState, useCallback, useMemo } from 'react';
import { Modal, Button, Popover, Spin } from 'antd';
import { remote } from '@boyuai/utils';
import CommonModal from './common-modal';
import './index.less';
import Guide from './guide';
import Pending from './pending';

const courses = [
    {
        link: 'https://www.boyuai.com/elites/course/zDQMBV778Mu9td4p',
        title: '深度学习',
        uuid: 'zDQMBV778Mu9td4p',
    },
    {
        link: 'https://www.boyuai.com/elites/course/xVqhU42F5IDky94x',
        title: '强化学习',
        uuid: 'xVqhU42F5IDky94x',
    },
    {
        link: 'https://www.boyuai.com/elites/course/9SPUuFz3rvpkmbkn',
        title: '自然语言处理',
        uuid: '9SPUuFz3rvpkmbkn',
    },
    {
        link: 'https://www.boyuai.com/elites/course/D91JM0bv72Zop1D3',
        title: '人工智能数学基础',
        uuid: 'D91JM0bv72Zop1D3',
    },
    {
        link: 'https://www.boyuai.com/elites/course/KFQ5E46KzWpHF9yf',
        title: '计算机视觉-深度',
        uuid: 'KFQ5E46KzWpHF9yf',
    },
    {
        link: 'https://www.boyuai.com/elites/course/SetWD393PgQjRMzv',
        title: '计算机视觉-经典',
        uuid: 'SetWD393PgQjRMzv',
    },
    {
        link: 'https://www.boyuai.com/elites/course/x3fyYxaRhVWJxGSI',
        title: '机器学习',
        uuid: 'x3fyYxaRhVWJxGSI',
    },
    {
        link: 'https://www.boyuai.com/elites/course/jbXtxc2nxNSz8CWH',
        title: '信息检索',
        uuid: 'jbXtxc2nxNSz8CWH',
    },
];

export default function Modal1({
    visible,
    onClose,
    activity,
    onActivityChange,
    pending,
}) {
    // const [popoverVisible, setPopoverVisible] = useState(false);
    // const [popoverAllowVisible, setPopoverAllowVisible] = useState(false);
    const [confirmModalVisible, setConfirmModalVisible] = useState(false);
    // const [warningModalVisible, setWarningModalVisible] = useState(false); // 没选课点邀请
    const [warningModalVisible2, setWarningModalVisible2] = useState(false); // 选了课还点选课
    const [currentCourseUuid, setCurrentCourseUuid] = useState(null);
    const [loading, setLoading] = useState(false);
    // 确认选择之后不立即更新（更新会切换到Modal2），先暂存，等点了邀请才更新
    const chooseCourse = useCallback(async () => {
        if (currentCourseUuid) {
            setLoading(true);
            const act = await remote.$patch(
                `/course/activities/${activity.id}/content`,
                { content: { course: currentCourseUuid } },
                { hideLoading: true, throwException: 'showMessage' }
            );
            onActivityChange(act);
            setConfirmModalVisible(false);
            setLoading(false);
        }
    }, [activity, onActivityChange, currentCourseUuid]);

    // const onInviteButtonClicked = useCallback(async () => {
    //     if (!activity.content.modal1InviteButtonClicked) {
    //         setLoading(true);
    //         const act = await remote.$patch(
    //             `/course/activities/${activity.id}/content`,
    //             { content: { modal1InviteButtonClicked: true } },
    //             { hideLoading: true }
    //         );
    //         onActivityChange(act);
    //     }
    // }, [onActivityChange, activity]);

    const popoverAllowVisible = useMemo(() => {
        return !(
            !visible ||
            confirmModalVisible ||
            // warningModalVisible ||
            warningModalVisible2 ||
            loading
        );
    }, [
        visible,
        confirmModalVisible,
        // warningModalVisible,
        warningModalVisible2,
        loading,
    ]);

    return (
        <Modal
            wrapClassName="activity-boyu-202008-modal"
            visible={visible}
            footer={null}
            onCancel={onClose}
            width={890}
        >
            <img
                onClick={() => onClose()}
                className="close-button"
                src="https://staticcdn.boyuai.com/materials/2020/08/01/U0eGfF6-XzSu3NdTrJvbU.png!png"
                alt="关闭"
            />
            <div className="activity-qianren-laxin-modal-content">
                <img
                    className="activity-qianren-laxin-modal-content-title"
                    style={{
                        top: 70,
                        left: 64,
                        width: 572,
                    }}
                    src="https://staticcdn.boyuai.com/materials/2020/08/01/XZFxN0QWRrMK-OqBIlq8b.png!png"
                    alt=""
                    // alt="春暖花开"
                />
                <img
                    className="activity-qianren-laxin-modal-content-thanks"
                    src="https://staticcdn.boyuai.com/materials/2020/08/01/9cD7ALfeMjyg04Gg_9HAT.png!png"
                    alt=""
                    // alt="感谢有你"
                    style={{
                        top: 100,
                        right: 96,
                        width: 200,
                    }}
                />
                {pending ? (
                    <Pending />
                ) : (
                    <Spin spinning={loading || pending}>
                        <div
                            className="activity-qianren-laxin-modal-content-box"
                            style={{
                                top: 250 - 24,
                                height: 280,
                                backgroundColor: 'unset', // 首页不要底色
                            }}
                        >
                            <Popover
                                {...(popoverAllowVisible &&
                                !activity.content.course
                                    ? {}
                                    : { visible: false })}
                                trigger="click"
                                content={
                                    <div className="activity-qianren-laxin-courses-popover">
                                        <div className="activity-qianren-laxin-courses-popover-hint">
                                            选择一门感兴趣的课程，邀请一位好友
                                            <br />
                                            之后每登录一天，即可解锁一个知识点
                                        </div>
                                        {courses.map(course => (
                                            <div
                                                className="activity-qianren-laxin-courses-popover-item"
                                                key={course.title}
                                            >
                                                <img
                                                    src="https://staticcdn.boyuai.com/materials/2020/06/17/GxmUkvjyRVFRMVJ9j_BOO.png!png"
                                                    alt=""
                                                    width="8px"
                                                    height="8px"
                                                />
                                                <span className="activity-qianren-laxin-courses-popover-item-container">
                                                    <span className="activity-qianren-laxin-courses-popover-item-title">
                                                        {course.title}
                                                    </span>
                                                    <span>
                                                        <a
                                                            href={course.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <Button>
                                                                查看
                                                            </Button>
                                                        </a>
                                                        <Button
                                                            onClick={() => {
                                                                if (
                                                                    remote.isLogin()
                                                                ) {
                                                                    // setPopoverVisible(
                                                                    //     false
                                                                    // );
                                                                    setConfirmModalVisible(
                                                                        true
                                                                    );
                                                                    setCurrentCourseUuid(
                                                                        course.uuid
                                                                    );
                                                                } else {
                                                                    remote.requestLogin();
                                                                }
                                                            }}
                                                        >
                                                            选择
                                                        </Button>
                                                    </span>
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                }
                                title={null}
                            >
                                <div
                                    className="activity-qianren-laxin-modal-content-box-button"
                                    style={{
                                        position: 'absolute',
                                        left: '64px',
                                        bottom: '56px',
                                    }}
                                    onClick={() => {
                                        if (!activity.content.course) {
                                            // setPopoverVisible(v => !v);
                                        } else {
                                            setWarningModalVisible2(true);
                                        }
                                    }}
                                >
                                    <div
                                        className="circle"
                                        style={{ backgroundColor: '#fff' }}
                                    >
                                        <img
                                            src="https://staticcdn.boyuai.com/materials/2020/02/07/mVo_e7lKqCln9mMDWXh5k.png!png"
                                            alt=""
                                            width="15px"
                                            height="12px"
                                        />
                                    </div>
                                    <div className="text space">领取课程</div>
                                    {!activity.content.course && (
                                        <Guide left={-86} top={0} />
                                    )}
                                </div>
                            </Popover>
                        </div>
                    </Spin>
                )}
                {/*<div className="activity-qianren-laxin-modal-content-explanation">*/}
                {/*    *&nbsp;&nbsp;本次活动最终解释权归伯禹人工智能学院所有*/}
                {/*</div>*/}
            </div>
            <CommonModal
                visible={confirmModalVisible}
                onCancel={() => {
                    setConfirmModalVisible(false);
                }}
                title={'您确定吗？'}
                hint={'确认选择课程后将不可更改'}
                onOk={() => chooseCourse()}
                okText={'确认选择'}
                buttonVisible={true}
                loading={loading || pending}
                imgSrc={
                    'https://staticcdn.boyuai.com/materials/2020/08/01/45bBYG6qUjt5BTnIWH1rD.png!png'
                }
            />
        </Modal>
    );
}
